import "./styles/App.css";
import { useState, useEffect } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import { PacmanLoader } from "react-spinners";

import Navbar from "./components/Navbar";
import LandingPage from "./components/LandingPage";
import Team from "./components/Team";
import About from "./components/About";
import Projects from "./components/Projects"
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  const storedDarkMode = localStorage.getItem("DARK_MODE");

  const [loading, setLoading] = useState(false);
  const [darkMode, setDarkMode] = useState(() => {
    if (storedDarkMode === "light" || storedDarkMode === "dark") {
      return storedDarkMode;
    } else {
      return "dark";
    }
  });
  //Theme now changes globaly with css variables
  document.documentElement.setAttribute("data-theme", darkMode);
  //Removes theme for overflow:hidden
  document.documentElement.setAttribute("datatheme", 'no__scroll');
  if (!loading) {
    document.documentElement.setAttribute("datatheme", '');
  }
  useEffect(() => {
    console.log(`Is in what mode? ${darkMode}`);
    localStorage.setItem("DARK_MODE", darkMode);
  }, [darkMode]);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  }, []);
  return (
    <>
      {loading ? (
        <div className='loading'>
          <PacmanLoader size={40} color="#ffff00" loading={loading} />
        </div>
      ) : (
        ''
      )}
      <Router>
        <ScrollToTop />
        <Navbar darkMode={darkMode} setDarkMode={setDarkMode} />
        <Route
          path="/"
          exact
          render={() => (
            <>
              <LandingPage darkMode={darkMode} />
            </>
          )}
        />
        <Route 
          path="/projects"
          exact
          render={() => (
            <>
              <Projects/>
            </>
          )}
        />
        <Route
          path="/team"
          exact
          render={() => (
            <>
              <Team />
            </>
          )}
        />
        <Route
          path="/about"
          exact
          render={() => (
            <>
              <About />
            </>
          )}
        />
        <Footer />
      </Router>
    </>
  );
}

export default App;
